import GLightbox from 'glightbox'
import {AjaxForm} from '../modules/AjaxForm.js'

/**
 * Modal
 * ======================================
 * - show popup based on zip code
 */

const MODAL = '.js-modal'

class Modal {
  constructor() {
    this.modal = document.querySelectorAll(MODAL)

    if (!this.modal) {
      return false
    }

    this.modal.forEach((el) => {
      el.addEventListener('click', this.openModal, false)
    })
  }

  openModal = (e) => {
    e.preventDefault()

    const CLOSE_BUTTON = '.js-close-lightbox'
    const content = document.querySelector('#modal-contact > div').cloneNode(true)

    const modal = GLightbox({
      skin: 'modal',
      height: 'auto',
      elements: [
          {
              'content': content
          },
      ],
    });
    modal.on('open', () => {
      new AjaxForm()
    });

    modal.open();

    // close
    document.querySelectorAll(CLOSE_BUTTON).forEach((el) => {
      el.addEventListener('click', function(){
        modal.close()
      })
    })
  }
}

new Modal()
